import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const DashboardOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      d="M9.92 3H4.39C3.62 3 3 3.62 3 4.39v7.58c0 .77.62 1.39 1.39 1.39h5.53c.77 0 1.39-.62 1.39-1.39V4.39c0-.77-.62-1.39-1.39-1.39Zm-.21 8.76H4.6V4.6h5.11v7.16ZM9.88 14.5H4.42c-.78 0-1.42.64-1.42 1.42v3.67c0 .78.64 1.42 1.42 1.42h5.46c.78 0 1.42-.64 1.42-1.42v-3.67c0-.78-.64-1.42-1.42-1.42Zm-.18 4.91H4.6V16.1h5.11v3.31H9.7ZM19.61 10.66h-5.53c-.77 0-1.39.62-1.39 1.39v7.58c0 .77.62 1.39 1.39 1.39h5.53c.77 0 1.39-.62 1.39-1.39v-7.58c0-.77-.62-1.39-1.39-1.39Zm-.21 8.76h-5.11v-7.16h5.11v7.16ZM19.58 3h-5.46c-.78 0-1.42.64-1.42 1.42v3.67c0 .78.64 1.42 1.42 1.42h5.46c.78 0 1.42-.64 1.42-1.42V4.42C21 3.64 20.36 3 19.58 3Zm-.18 4.91h-5.11V4.6h5.11v3.31Z"
      fill={color}
    />
  </Svg>
)

export default DashboardOutlined
